import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { I18nService } from '../../../../services/utils/i18n.service'
import { FloatingContainerTitle } from '../casting-styled.component'
import CastingFrequencyPeriodPickerComponent from './casting-frequency-period-picker.component'
import CastingFrequencyWeekIntervalPickerComponent from './casting-frequency-week-interval-picker.component'

const i18nScoped = new I18nService(require('./casting-frequency-content.component.yml'))

export default function CastingFrequencyContentComponent ({ store, data, data: { slots, offeredService } }: StoreProps) {
  /** allowing any time means you are available 24h/7d */
  const toggleAllowAnyTime = React.useCallback (() => {
    if (store.toggleAllowAnyTime() && slots[0].weeks_interval) store.nextFocus({ closeOnMobile: true })
  }, [slots, store])

  const shouldRenderStartTimes = offeredService.rentable_unit_of_work !== 'day' && !offeredService.no_start_time_nor_duration_asked_to_customer

  return <>
    <CastingFrequencyWeekIntervalPickerComponent data={ data } store={ store } />

    { shouldRenderStartTimes && <>
      <FloatingContainerTitle>{ i18nScoped.t('frequency_time_window') }</FloatingContainerTitle>

      <div className="inputRadio">
        <input id="no-timespan" type="checkbox" checked={ store.isAllowingAnyTime() } onChange={ toggleAllowAnyTime } />
        <label htmlFor="no-timespan">{ i18nScoped.t('no_timespan') }</label>
      </div>

      { !store.isAllowingAnyTime() && <CastingFrequencyPeriodPickerComponent data={ data } store={ store } /> }
    </> }
  </>
}
